import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from './serviceHelper'

export const processTemplateService = {
  getProcessTemplate: async (user, processTemplateId) => {
    return await axios.get(
      `${NODE_BASE_URL}/template/process/${processTemplateId}`,
      getAxiosOptions(user)
    )
  },
  getTemplateListForAdmin: async (user, processTemplateId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/template/field/process/${processTemplateId}`,
        getAxiosOptions(user)
      )
    ).data
  },
  getProcessForCategory: async (user) => {
    return await axios.get(`${NODE_BASE_URL}/template/process/category`, getAxiosOptions(user))
  },
  savedProcessCategories: (user, processCategoryId, categoryContext) => {
    return axios.post(
      `${NODE_BASE_URL}/user/user-detail/save-user-process-categories`,
      {
        user_id: user.id,
        process_category_id: processCategoryId,
        category_context: categoryContext,
      },
      getAxiosOptions(user)
    )
  },
  getProtectedList: async (user, processTemplateId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/admin/process/protected-list/${processTemplateId}`,
        getAxiosOptions(user)
      )
    ).data
  },
  addEditProtectedList: async (user, data) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/process/protected-list/add-edit`,
        data,
        getAxiosOptions(user)
      )
    ).data
  },
  getLinkedProcesses: async (user, pivotFieldId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/admin/process/linked-process/${pivotFieldId}`,
        getAxiosOptions(user)
      )
    ).data
  },
}
